/**
 * De enum geeft alle menu items weer en daarbij de volgorde van de menu items.
 * Hierdoor heb je een makkelijk overzicht van alle menu items.
 * En is het heel makkelijk om de volgorde aan te passen.
 */
export enum MenuItems {
  Dashboard,
  Risicoscan,
  VoorlopigeDekkingen,
  OffrerenAanvragen,
  MuterenRoyeren,
  Relaties,
  Schade,
  AanvragenHeader,
  Aanvragen,
  Mutaties,
  Maatwerk,
  Overvoer,
  Taken,
  Inspectierapporten,
  Premievaststelling,
  Prolongatie,
  Werkvoorraad,
  PtsOverzicht,
  Alerts,
  BeheerHeader,
  BeheerBox,
  Adviseurbeheer,
  RapportageIntern,
  SbLandkaart,
  OverzichtenHeader,
  Contact,
  Instellingen,
  Overzichten,
  Financieel,
}
